import React from 'react';
import { Form, Radio } from 'tdesign-react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { useEventEmitter } from 'ahooks';
import ColTip from '@/components/Tip';
import ExamineMessage from './ExamineMessage';
import MessageDataModal from './MessageDataModal';
import PeekMessages from './PeekMessages';
import GetMessageById from './GetMessageById';

const { FormItem } = Form;

export const columns = [
  {
    colKey: 'messageId',
    title: (
      <ColTip
        content={
          <>
            <strong>消息ID</strong>
            <li>1、非批量消息：ledgerId : entryId : partitionIndex。</li>
            <li>2、批量消息：ledgerId : entryId : partitionIndex : batchIndex。</li>
            <p></p>
            <li>例如12385:6:48:0代表为批量消息中第1条消息。</li>
          </>
        }
      >
        消息ID
      </ColTip>
    ),
    cell: ({ row }) => row.messageId || '-',
    width: 130,
  },
  {
    colKey: 'key',
    title: '消息KEY',
    cell: ({ row }) => row.key || '-',
    width: 200,
  },
  {
    colKey: 'partition',
    title: 'Partition',
    width: 100,
  },
  {
    colKey: 'producerName',
    title: '生产者',
    width: 180,
  },
  {
    colKey: 'clientPublishTime',
    title: (
      <ColTip
        content={
          <>
            <strong>生产时间</strong>
            <li>客户端发布时间。</li>
          </>
        }
      >
        生产时间
      </ColTip>
    ),
    cell: ({ row }) => dayjs(row.clientPublishTime).format('YYYY-MM-DD HH:mm:ss'),
    width: 180,
  },
  // {
  //   colKey: 'messageNum',
  //   title: '批量条数',
  //   width: 140,
  // },
  {
    colKey: 'properties',
    title: (
      <ColTip
        content={
          <>
            <strong>自定义属性</strong>
            <li>消息自定义属性</li>
          </>
        }
      >
        自定义属性
      </ColTip>
    ),
    width: 180,
    cell: ({ row }) => <MessageDataModal data={row.properties} />,
  },
  {
    colKey: 'data',
    width: 180,
    title: (
      <ColTip
        content={
          <>
            <strong>消息体</strong>
            <li>统一按照转字节转换为字符串展示。</li>
          </>
        }
      >
        消息体
      </ColTip>
    ),
    cell: ({ row }) => <MessageDataModal data={row.data} />,
  },
];

export default function MessagePanel({ commonProps }) {
  const [form] = Form.useForm();
  const tag = Form.useWatch('tab', form);
  const searchEvent$ = useEventEmitter();

  return (
    <>
      <Form form={form} style={{ marginTop: 12 }}>
        <FormItem name='tab' initialData={1} className='hack_radio_button_theme'>
          <Radio.Group variant='primary-filled'>
            <Radio.Button value={1}>
              {' '}
              {
                <ColTip
                  content={
                    <>
                      <strong>检查最新消息</strong>
                      <li>最近位点：检查最新收到的一条消息。</li>
                      <li>最早位点：检查最早收到的一条消息。</li>
                    </>
                  }
                >
                  检查最新消息
                </ColTip>
              }
            </Radio.Button>
            <Radio.Button value={2}>
              {
                <ColTip
                  content={
                    <>
                      <strong>根据订阅名</strong>
                      <li>指定订阅名，查询未消费的n条消息。</li>
                    </>
                  }
                >
                  根据订阅名
                </ColTip>
              }
            </Radio.Button>
            <Radio.Button value={3}>精确查询</Radio.Button>
          </Radio.Group>
        </FormItem>
      </Form>
      <Container>
        {tag === 1 && <ExamineMessage commonProps={commonProps} />}
        {tag === 2 && <PeekMessages commonProps={commonProps} />}
        {tag === 3 && <GetMessageById searchEvent$={searchEvent$} commonProps={commonProps} />}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding: 10px 4px;
`;
